import ReactDOM from "react-dom";
import { usePortalReference } from "./PortalReferenceStore";
import { PropsWithChildren } from "react";

export const ModalPortal = ({ children }: PropsWithChildren) => {
    const { portalRef } = usePortalReference();

    return portalRef?.current
        ? ReactDOM.createPortal(children, portalRef.current)
        : children;
};
